// extracted by mini-css-extract-plugin
export default {"btnClose":"ButtonClose_btnClose__pG56O"};